import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import AnswerHeader from "components/answer/Header";
import { openMenu, closeMenu } from "redux/modules/answer/answerHeader";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader
});

const mapDispatchToProps = dispatch => ({
  handleLogout: () => {
    window.close();
  },
  openMenu: event => dispatch(openMenu(event)),
  closeMenu: () => dispatch(closeMenu())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AnswerHeader)
);



// WEBPACK FOOTER //
// ./src/containers/preview/AnswerHeaderContainer.js